module.exports = __webpack_public_path__ + "media/images/pin-purple-66af97e89da193363783b014bdccb147.png";